module.exports = __webpack_public_path__ + "a0a3a278dd6eda28a54942dd72a2b926.png";